import AuthenticationLayout from 'components/AuthLayout';
import { FC } from 'react';
import { Route, Routes } from 'react-router-dom';
import useSWR from 'swr';
import Redirect from '../redirect';
import VerifiedEmailRequired from '../user/error/verified-email-required';
import AdminActions from './actions';
import AdminRequired from './error/admin-required';
import FilesRoutes from './files/Routes';
import MenteesRoutes from './mentoring/mentees/Routes';
import MentorsRoutes from './mentoring/mentors/Routes';
import Referees from './mentoring/referees';

const AdminRoutes: FC = () => {
  const { error } = useSWR('/auth/admin');
  return error?.response?.status === 401 ? (
    <AuthenticationLayout src_image="/logo_institut_principal.png">
      <AdminRequired />
    </AuthenticationLayout>
  ) : error?.response?.status === 403 ? (
    <AuthenticationLayout src_image="/logo_institut_principal.png">
      <VerifiedEmailRequired />
    </AuthenticationLayout>
  ) : (
    <Routes>
      <Route path="/" element={<Redirect href="/admin/mentoring/mentees" />} />
      <Route path="/actions/*" element={<AdminActions />} />
      <Route
        path="/mentoring"
        element={<Redirect href="/admin/mentoring/mentees" />}
      />
      <Route path="/mentoring/mentees/*" element={<MenteesRoutes />} />
      <Route path="/mentoring/mentors/*" element={<MentorsRoutes />} />
      <Route path="/mentoring/referees/*" element={<Referees />} />
      <Route path="/files/*" element={<FilesRoutes />} />
    </Routes>
  );
};

export default AdminRoutes;
